import { useNavigate } from "react-router-dom";
import EditButton from "../Buttons/EditButton";
import Card from "../Card";
import { RoutesLink } from "../../router/RoutesLink";
import Paragraphs from "../Texts/Paragraphs";

const ProfileCard = ({ name, UserImg, docTitle, doc }) => {
  const navigate = useNavigate();

  return (<Card className="py-[16px] px-[12px] mt-[32px] flex justify-between max-w-[100%] md:max-w-[70%]">

    <div className="flex flex-row items-center">
      <img
        src={UserImg}
        alt="User img"
        className="object-contain w-[53px] h-[53px] md:w-[83px] md:h-[83px] xl:w-[116px] xl:h-[116px] rounded-[116px]"
      />
      <div className="ml-[18px] md:ml-[28px]">
        <p className="font-Apparat font-[700] text-[16px] md:text-[20px] lg:text-[24px] leading-[28.8px]">{name}</p>
        <Paragraphs
          text={docTitle}
          className="text-[#42495259] mt-[9px] font-[600]"
        />
        {/* <p className="font-Apparat font-[600] text-[20px] leading-[24px] text-[#42495259] mt-[9px]">
          {docTitle}
        </p> */}
        <Paragraphs
          text={doc}
          className="text-[#424952cc] mt-[9px] font-[600]"
        />
      </div>
    </div>

    <EditButton
      title="Update"
      variant="secondary"
      onClick={() => navigate(RoutesLink?.myAccount)}
      className="!border-primary font-[600] text-primary"
    />

  </Card>)
}

export default ProfileCard;